import { loader } from "@monaco-editor/react";

let configured = false;

/**
 * Load Monaco via its AMD build from `/monaco/vs` (served by Bun / copied into dist).
 * Bundling the ESM package under Bun breaks workers (`file://` dynamic imports).
 */
export function ensureMonacoConfigured(): void {
  if (configured || typeof window === "undefined") {
    return;
  }
  configured = true;

  // Absolute path on the app origin (works for localhost and Tauri asset hosts).
  const vsPath = new URL("/monaco/vs", window.location.href).href.replace(/\/$/, "");
  loader.config({ paths: { vs: vsPath } });

  if (!document.getElementById("monaco-editor-css")) {
    const link = document.createElement("link");
    link.id = "monaco-editor-css";
    link.rel = "stylesheet";
    link.href = `${vsPath}/editor/editor.main.css`;
    document.head.appendChild(link);
  }
}
